import React from "react";
import classes from "./Spinner.module.scss";

interface SpinnerProps {
  width?: number;
  height?: number;
}

const Spinner: React.FC<SpinnerProps> = ({ width = 40, height = 40 }) => {
  return <span className={classes.spinner} style={{ width, height }} />;
};

export default Spinner;
